import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button, Col, Row, Icon, Popconfirm, message,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit, faEye, faTrash,
} from '@fortawesome/free-solid-svg-icons';
import ServerSideTable from '../../components/ServerSideTable';
import DriverClusterUpdateModal from '../picklist/DriverClusterUpdateModal';
import {
  driverClusterPackagesFetch
} from '../ducks';
import { set } from 'lodash';
function DriverClusterList({
  tableFilter, data, onTableUpdate, fetchingTableDetails, branchCodeList,user, ...props
}) {
const styleTableHeader = width => ({
  borderCollapse: 'collapse',
  border: '1px solid black',
  fontSize: '12px',
  padding: '5px',
  width,
});
  const [rowDetails, setRowDetails] = useState({
    id: null,
    branch: null,
    cluster: null,
    route_code: null,
  });
  const [driverClusterPackage,setDriverClusterPackage] = useState([]);
  const [driverCluster,setDriverCluster] = useState();
  const [driverClusterPackageCwt,setDriverClusterPackageCwt] = useState();

  const [editModalVisibility, setEditModalVisibility] = useState(false);

  const printDispatch = (driverCluster) => {
      const {doDriverClusterPackagesFetch} = props;
      const payload = {
        driver_cluster_id: driverCluster.id
      };
      setDriverCluster(driverCluster);
      doDriverClusterPackagesFetch(payload).then((res)=>{
        const data = res.payload.data;
        setDriverClusterPackage(data.data);
        setDriverClusterPackageCwt(data.total_cwt);
        const content = document.getElementById('divcontents');
        const pri = document.getElementById('ifmcontentstoprint').contentWindow;
        pri.document.open();
        pri.document.write(content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
      });
      
    }
  // function DeleteDataRow(dataId) {
  //   doDeletePortClusterRequest(dataId).then((res) => {
  //     message.success(res.payload.data.message);
  //     onTableUpdate({
  //       ...tableFilter,
  //       page: tableFilter.page - 1,
  //     });
  //   }).catch(() => {
  //     message.error('Something wen`t wrong, please try again later.');
  //   });
  // }
 
const [columnVisibility, setColumnVisibility] = useState({
  driver_name: false, // hide age column
});
  return (
    <React.Fragment>
      <DriverClusterUpdateModal
        editModalVisibility={editModalVisibility}
        setEditModalVisibility={setEditModalVisibility}
        rowDetails={rowDetails}
        setRowDetails={setRowDetails}
        tableFilter={tableFilter}
        onTableUpdate={onTableUpdate}
        branchCodeList={branchCodeList}
      />
      <ServerSideTable
        data={data.rows}
        pages={data.pages}
        columns={[
          {
            Header: 'Id',
            accessor: 'id',
          },
          {
            Header: 'Driver Name',
            accessor: 'driver_name',
          },
          {
            Header: 'Cluster',
            accessor: 'cluster',
          },
          {
            Header: 'Package Count',
            accessor: 'package_count',
          },
          {
            Header: 'CWT Count',
            accessor: 'cwt_count',
          },
          {
            Header: 'Vehicle',
            accessor: 'vehicle_name',
          },
          {
            Header: 'Vehicle Id',
            accessor: 'vehicle_id',
          },
          {
            Header: 'Maximum TNs',
            accessor: 'maximum_tn',
          },
          {
            Header: 'Minimum CWT',
            accessor: 'minimum_cwt',
          },
          {
            Header: 'Maximum CWT',
            accessor: 'maximum_cwt',
          },
          {
            Header: 'Priority',
            accessor: 'prio',
          },
          {
            Header: 'Options',
            sortable: false,
            filterable: false,
            // eslint-disable-next-line no-unused-vars
            Cell: info => (
              <Row>
                <Col span={11}>
                  <Button
                    type="link"
                    block
                    onClick={() => {
                      printDispatch(info.original);
                    }}
                  >
                    <Icon viewBox="0 0 1024 1024">
                      <FontAwesomeIcon icon={faEye} fixedWidth />
                    </Icon>
                      View
                  </Button>
                </Col>
                {[1,2,18].includes(user.role_id) ? <Col span={11}>
                  <Button
                    type="link"
                    block
                    onClick={() => {
                      setRowDetails(info.original);
                      setEditModalVisibility(true);
                    }}
                  >
                    <Icon viewBox="0 0 1024 1024">
                      <FontAwesomeIcon icon={faEdit} fixedWidth />
                    </Icon>
                      Edit
                  </Button>
                </Col> : ''}
                {/* <Col span={11}>
                  <Popconfirm
                    placement="topLeft"
                    title="Are you sure you want to delete this port cluster?"
                    okText="Yes"
                    cancelText="No"
                    // onConfirm={() => { DeleteDataRow(info.row.id); }}
                  >
                    <Button type="link">
                      <Icon viewBox="0 0 1024 1024">
                        <FontAwesomeIcon icon={faTrash} fixedWidth />
                      </Icon>
                        Delete
                    </Button>
                  </Popconfirm>
                </Col> */}
              </Row>
            ),
          },
        ]}
        loading={fetchingTableDetails}
        loadingText="Fetching Pick list..."
        onFetchData={onTableUpdate}
      />
            <div style={{ display: 'none' }} id="divcontents">
          <center>
            <strong style={{ fontSize: '14px' }}>Pick List</strong>
          </center>
          <div style={{ marginBottom: '20px' }}>
            <img
              style={{ float: 'left' }}
              src="http://portal.xdelogistics.com/public/img/xde-logo.png"
              alt="xdeLogo"
            />
            <div
              style={{
                float: 'left',
                paddingTop: '15px',
                marginLeft: '20px',
                width: '570px',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>XDE Logistics</strong>
              </p>
              <p style={{ fontSize: '12px', margin: '5px' }}>
                Ximex Building, #9B , Industrial Complex, Bagumbayan, Bicutan, 1st Ave, Taguig, 1631
                Metro Manila
              </p>
            </div>
          </div>
          <div
            style={{
              content: '',
              display: 'inline-block',
              verticalAlign: 'middle',
              width: '100%',
              marginTop: '20px',
            }}
          >
            <div
              style={{
                width: '33%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
                float: 'left',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Driver: </strong>
                {driverCluster ? driverCluster.driver_name : ''}
              </p>
            </div>
            <div
              style={{
                width: '33%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Created at: </strong>
                {driverClusterPackage ? driverClusterPackage.created_at : ''}
              </p>
            </div>
            <div
              style={{
                width: '33%',
                display: 'inline-block',
                verticalAlign: 'middle',
                textAlign: 'middle',
              }}
            >
              <p style={{ fontSize: '12px', margin: '5px' }}>
                <strong>Vehicle: </strong>
                {driverCluster ? driverCluster.vehicle_name : ''}
              </p>
            </div>
          </div>
          <div
            style={{
              content: '',
              display: 'inline-block',
              verticalAlign: 'middle',
              width: '33%',
              marginBottom: '15px',
            }}
          >
          </div>
          <div
            style={{
              content: '',
              display: 'inline-block',
              verticalAlign: 'middle',
              width: '33%',
              marginBottom: '15px',
            }}
          >
          </div>
          <div style={{ marginBottom: '30px' }}>
            <table style={{ borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={styleTableHeader('15%')}>Waybill #</th>
                  <th style={styleTableHeader('15%')}>Cluster</th>
                  <th style={styleTableHeader('15%')}>Status</th>
                  <th style={styleTableHeader('15%')}>Length</th>
                  <th style={styleTableHeader('15%')}>Width</th>
                  <th style={styleTableHeader('15%')}>Height</th>
                  <th style={styleTableHeader('15%')}>Weight</th>
                  <th style={styleTableHeader('15%')}>CWT</th>
                  <th style={styleTableHeader('15%')}>Handover Date</th>
                </tr>
              </thead>
              <tbody>
                {
                  driverClusterPackage
                    ? driverClusterPackage.map((val, key) => (
                      <tr key={key}>
                        <td style={styleTableHeader('15%')}>{val.tracking_number}</td>
                        <td style={styleTableHeader('15%')}>{val.cluster}</td>
                        <td style={styleTableHeader('15%')}>{val.status}</td>
                        <td style={styleTableHeader('15%')}>{val.length}</td>
                        <td style={styleTableHeader('15%')}>{val.width}</td>
                        <td style={styleTableHeader('15%')}>{val.height}</td>
                        <td style={styleTableHeader('15%')}>{val.weight}</td>
                        <td style={styleTableHeader('15%')}>{val.cwt}</td>
                        <td style={styleTableHeader('15%')}>{val.handover_date}</td>

                      </tr>
                    )) : null
                }
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: '12px', margin: '5px' }}>
            Total Packages:
            {' '}
            <span style={{ color: 'red' }}>{driverClusterPackage ? driverClusterPackage.length : 0}</span>
          </p>
          <p style={{ fontSize: '12px', margin: '5px' }}>
            Total CWT:
            {' '}
            <span style={{ color: 'red' }}>{driverClusterPackageCwt ? driverClusterPackageCwt : 0}</span>
          </p>
        </div>
          <iframe
          title="myFrame"
          id="ifmcontentstoprint"
          style={{ height: '0px', width: '0px', position: 'absolute' }}
        />
      
    </React.Fragment>

  );
}


DriverClusterList.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  tableFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  branchCodeList: PropTypes.oneOfType([PropTypes.array]).isRequired,
  onTableUpdate: PropTypes.func.isRequired,
  doDeletePortClusterRequest: PropTypes.func.isRequired,
  fetchingTableDetails: PropTypes.bool.isRequired,
  doDriverClusterPackagesFetch: PropTypes.func.isRequired,
  user: PropTypes.oneOfType([PropTypes.object]).isRequired,
  
};

const mapDispatchToProps = {
  doDriverClusterPackagesFetch: driverClusterPackagesFetch,
};

const mapStateToProps = state => ({
  user: state.auth.user,
});
export default connect(mapStateToProps, mapDispatchToProps)(DriverClusterList);
